import {
    MATERIAL_STATUS_APPROVED,
    MATERIAL_STATUS_EVALUATING,
} from 'constants/wallMaterials';

import {formatVideoLength} from './media';

import {t} from 'l10n';

const moment = require('moment');

export function formatDate(wallPost, extended = false) {
    let format = t('MM/DD/YYYY');
    if (extended) {
        format = t('MM/DD/YYYY [at] HH:mm')
    }

    let date = wallPost.publish_date || wallPost.submit_date;
    return moment(date).format(format);
}

export function getMSLength(wallMaterial, writeHours = false) {
    let {length} = wallMaterial;

    return length ? formatVideoLength(length, writeHours) : null;
}

export function isPublished(wallMaterial) {
    return wallMaterial && [MATERIAL_STATUS_EVALUATING, MATERIAL_STATUS_APPROVED].indexOf(wallMaterial.status) !== -1;
}

export function formatCommentDate(filmAmateurComment, extended = false) {
    return moment(filmAmateurComment.date).format(t('MM/DD/YYYY [at] HH:mm'))
}

export function getMaterialHash(wallMaterial) {
    return '#post-' + parseInt(wallMaterial.id);
}


// WEBPACK FOOTER //
// ./src/utils/wallMaterials.js